import type { State } from '../core/state';
import { errorToParts, now } from '../core/util';
import type { WidgetEvent } from '../types';

export type Emit = (event: WidgetEvent) => void;

/** window.onerror + unhandledrejection → js_error events. */
export function installErrorCollector(state: State, emit: Emit): () => void {
  const onError = (e: ErrorEvent) => {
    const parts = e.error ? errorToParts(e.error) : { message: e.message || 'Script error' };
    record(parts.message, parts.stack ?? (e.filename ? `at ${e.filename}:${e.lineno}:${e.colno}` : undefined));
  };
  const onRejection = (e: PromiseRejectionEvent) => {
    const parts = errorToParts(e.reason);
    record(`Unhandled promise rejection: ${parts.message}`, parts.stack);
  };

  function record(message: string, stack?: string) {
    const at = now();
    const safeMessage = state.redactor.text(message).slice(0, 2000);
    const safeStack = stack ? state.redactor.text(stack).slice(0, 20000) : undefined;
    state.jsErrors.push({ message: safeMessage, stack: safeStack, at });
    emit({ type: 'js_error', level: 'error', message: safeMessage, stack: safeStack, url: location.href, occurred_at: at });
  }

  window.addEventListener('error', onError);
  window.addEventListener('unhandledrejection', onRejection);
  return () => {
    window.removeEventListener('error', onError);
    window.removeEventListener('unhandledrejection', onRejection);
  };
}
